import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CharginBilletCreatePage } from './billet/billet-create/billet-create.page';
import { CharginBilletEmitPage } from './billet/billet-emit/billet-emit.page';
import { CharginBilletDetailedPage } from './billet/billet-emit-detailed/billet-emit-detailed.page';
import { CharginBilletEmitConfirmation } from './billet/billet-emit-confirmation/billet-emit-confirmation.page';
import { CharginBilletViewDetail } from './billet/billet-view-detail/billet-view-detail.page';
import { CharginBilletEdit } from './billet/billet-edit/billet-edit.page';
import { CharginBilletList } from './billet/billet-list/billet-list.page';

import { CharginBilletLotEmitDetailed } from './billet/lot-emit-detailed/lot-emit-detailed.page';
import { CharginBilletLotViewDetail } from './billet/billet-lot-view-detail/billet-lot-view-detail.page';
import { CharginBilletEmitIndividual } from './billet/billet-emit-individual/billet-emit-individual.page';
import { CharginBilletManagementPage } from './billet/billet-management/billet-management.page';

const routes: Routes = [
  {
    path: 'billet',
    children: [
      {
        path: '',
        redirectTo: 'billet',
        pathMatch: 'full',
      },
      {
        path: 'v1/list',
        component: CharginBilletCreatePage,
      },
      {
        path: 'v2/list',
        component: CharginBilletManagementPage,
      },
      {
        path: 'v1/emit',
        component: CharginBilletEmitPage,
      },
      {
        path: 'v2/emit-individual',
        component: CharginBilletEmitIndividual,
      },
      {
        path: 'v2/emit-multi-payer',
        component: CharginBilletEmitIndividual,
      },
      {
        path: 'v2/emit-detailed',
        component: CharginBilletDetailedPage,
      },
      {
        path: 'v2/emit-confirmation',
        component: CharginBilletEmitConfirmation,
      },
      {
        path: 'view', // lista de lote individual
        component: CharginBilletViewDetail,
      },
      // {
      //   path: 'v2/edit/:uuidAccountPayment/:uuidLot/:uuidBillet', // edit multi pagador
      //   component: CharginBilletEdit,
      // },
      {
        path: 'v2/edit/:uuidBillet', // edit multi pagador
        component: CharginBilletEdit,
      },
      {
        path: 'v2/emit-confirmation-multi/:uuidAccountPayment/:uuidLot',
        component: CharginBilletList,
      },
      {
        path: 'v2/emit-multi',
        component: CharginBilletLotEmitDetailed,
      },
      {
        path: 'v2/lot/:uuidAccountPayment/:uuidLot',  // lista de lote multi pagador
        component: CharginBilletLotViewDetail,
      },

    ],
  },
  {
    path: 'transfer',
    loadChildren: './transfer/transfer.module#TransferModule',
  },
  {
    path: 'transfer-tef',
    loadChildren: './transfer-tef/transfer.module#TransferTEFModule',
  },
  {
    path: 'favorites',
    loadChildren: () => import('./favorites/favorites.module').then((m) => m.FavoritesModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class ChargingRoutingModule { }
